import React, { useState, useEffect } from "react";
import { MdArrowForwardIos } from "react-icons/md";
import about from "../assets/about.jpg";
import companyVideo from "../images/company_video02.mp4";
import companyThumb from "../images/company_video02.jpg";
import Navigation from "./Navigation";
import Footer from "./Footer";
import Vision from "./Vision";
import { IoMdClose } from "react-icons/io";
import { FaPlay } from "react-icons/fa";
import ExecutiveTeamSection from "./ExecutiveTeamSection";
import { Link } from "react-router-dom";

const About = () => {
  const [playVideo, setPlayVideo] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  // Simple visibility animation trigger
  useEffect(() => {
  // Scroll to top when component mounts
  window.scrollTo(0, 0);

  const timeout = setTimeout(() => setIsVisible(true), 200);

  return () => clearTimeout(timeout);
}, []);


  return (
    <div>
      {/* Navigation */}
      <div className="sticky top-0 z-50 w-full bg-white shadow-md">
        <Navigation />
      </div>

      {/* Hero Section with Parallax Effect */}
      <div className="relative h-[210px] overflow-hidden">
        <img
          src={about}
          alt="About Us Banner"
          className="w-full h-[210px] object-cover transform transition-transform duration-1000 hover:scale-105"
        />
        <div className="absolute inset-0 flex items-center justify-start px-4 xl:px-20 bg-black/50">
          <h1
            className={`uppercase text-xl md:text-2xl lg:text-5xl text-white transform transition-all duration-700 ${isVisible
                ? "translate-x-0 opacity-100"
                : "-translate-x-10 opacity-0"
              }`}
          >
            ABOUT US
          </h1>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="w-full px-4 xl:px-20 py-5 xl:py-6">
        <div
          className={`flex flex-wrap items-center gap-2 text-md md:text-lg transform transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"
            }`}
        >
          <Link
            to="/"
            className="uppercase text-green-700 hover:underline transition-colors duration-300"
          >
            Home
          </Link>
          <MdArrowForwardIos className="text-gray-600 text-xs mt-0.5" />
          <p className="uppercase text-md md:text-lg text-gray-800">About Us</p>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="max-w-5xl mx-auto px-4 py-6 text-center">
        <h2 className="text-2xl md:text-4xl font-semibold text-gray-800 mb-6">
          A Legacy of Safety and Innovation
        </h2>
        <p className="text-gray-600 text-md md:text-lg leading-relaxed mx-auto text-justify">
          Founded with a mission to safeguard lives and property,{" "}
          <b>Nohmi Bosai (India) Pvt. Ltd.</b> stands as a trusted name in the fire
          protection industry. As part of the globally renowned Nohmi Bosai
          Group, we blend decades of Japanese engineering excellence with Indian
          innovation to deliver reliable, efficient, and sustainable fire safety
          solutions.
        </p>
        <p className="text-gray-600 text-md md:text-lg mt-4 leading-relaxed text-justify mx-auto">
          From intelligent detection systems to complete fire suppression
          networks, our commitment is simple — to protect people, property, and
          the planet through continuous innovation, ethical practices, and
          world-class service.
        </p>
      </div>

      {/* Company Video Section */}
      <div className="max-w-6xl mx-auto bg-gray-100 px-6 py-16 mt-4 flex flex-col items-center">
        <div className="w-full md:w-3/4 lg:w-2/3 bg-black shadow-lg rounded-xl overflow-hidden relative">

          {playVideo ? (
            <div className="relative w-full">
              <video
                src={companyVideo}
                controls
                autoPlay
                className="w-full h-auto object-contain"
              />
              {/* Close Button */}
              <button
                onClick={() => setPlayVideo(false)}
                className="absolute top-2 right-2 bg-black bg-opacity-70 p-2 rounded-full hover:bg-opacity-90 transition z-10"
              >
                <IoMdClose className="text-white text-2xl" />
              </button>
            </div>
          ) : (
            <div
              className="relative w-full h-auto cursor-pointer"
              onClick={() => setPlayVideo(true)}
            >
              <img
                src={companyThumb}
                alt="Company Introduction"
                className="w-full h-auto object-contain"
              />

              <div className="absolute inset-0 flex items-center justify-center">
                <div className="bg-black bg-opacity-60 px-4 py-3 rounded-md shadow-lg">
                  <FaPlay className="text-white text-xl" />
                </div>
              </div>
            </div>
          )}
        </div>

        <p className="mt-4 text-gray-700 text-md md:text-lg font-medium">
          Nohmi Introduction Video
        </p>
      </div>
      <div>
        <Vision />
      </div>
      <div>
        <ExecutiveTeamSection />
      </div>
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default About;